import * as React from "react";
import type { SVGProps } from "react";
const SvgCrossMedium = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M5.29 18.71c.2.19.45.29.71.29s.51-.09.71-.29l5.286-5.295 5.294 5.295c.2.19.45.29.71.29v-.01a.996.996 0 0 0 .71-1.7l-5.295-5.295L18.7 6.7a.996.996 0 1 0-1.41-1.41l-5.288 5.292L6.71 5.29c-.39-.39-1.03-.39-1.42 0s-.39 1.03 0 1.42l5.293 5.293L5.29 17.3a.996.996 0 0 0 0 1.41"
    />
  </svg>
);
export default SvgCrossMedium;
